var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKickIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 22,
    viewBox: "0 0 66 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.771484 0.601074H7.68452V5.17266H9.98884V2.88686H12.2932V0.601074H19.2063V7.45845H16.9019V9.74421H14.5976V12.0301H16.9019V14.3158H19.2063V21.1732H12.2932V18.8874H9.98884V16.6016H7.68452V21.1732H0.771484V0.601074ZM46.8584 0.601074H53.7714V5.17266H56.0758V2.88686H58.3801V0.601074H65.2931V7.45845H62.9888V9.74421H60.6845V12.0301H62.9888V14.3158H65.2931V21.1732H58.3801V18.8874H56.0758V16.6016H53.7714V21.1732H46.8584V0.601074ZM21.5106 0.601074H28.4236V21.1732H21.5106V0.601074ZM37.641 0.601074H33.0323V2.88686H30.7279V18.8874H33.0323V21.1732H37.641H44.554V14.3158H37.641V7.45845H44.554V0.601074H37.641Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKickIcon);
export default __webpack_public_path__ + "static/media/kickIcon.ed4c762ca9a8f4f3676e928e640798e4.svg";
export { ForwardRef as ReactComponent };